import * as actionTypes from './../actions/dailyIntakeAction';

const initialState = {
  data: [],
  rer: null,
  pending: true,
  error: null,
  ready: false,
};

const reducer = ( state = initialState, action ) => {
  switch ( action.type ) {
    case actionTypes.SET_RER:
      return {
        ...state,
        rer: action.rer,
      };
    case actionTypes.SET_DER:
      return {
        ...state,
        der: action.der,
      };
    case actionTypes.DEFAULT:
      return {
        ...state,
        ready: true,
      };
    case actionTypes.FETCH_DATA_PENDING:
      return {
        ...state,
        pending: true
      };
    case actionTypes.FETCH_DATA_SUCCESS:
      return {
        ...state,
        pending: false,
        data: action.data
      };
    case actionTypes.FETCH_DATA_ERROR:
      return {
        ...state,
        pending: false,
        error: action.error
      };
    default:
      return state;
  }
};

export default reducer;
